module.exports = __webpack_public_path__ + "static/group-4-640e5f1c0b1ffc969f232ff66a7fd7ff.jpg";